import { render } from "./ToolTip.vue?vue&type=template&id=563cff0e&scoped=true&ts=true"
import script from "./ToolTip.vue?vue&type=script&lang=ts"
export * from "./ToolTip.vue?vue&type=script&lang=ts"

import "./ToolTip.vue?vue&type=style&index=0&id=563cff0e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563cff0e"]])

export default __exports__